import { useRef, useState } from 'react';
import Icon, { IconType } from 'components/Icon';
import SmallIconButton, { SmallIconButtonState } from '../Button/SmallIconButton';
import * as S from './styles';
import { Attachment } from 'dragonmouse-shared/interfaces';
import { Loader } from 'components/Widget/Loader';
import { useTheme } from 'styled-components';

export enum ChatAttachmentTileState {
	REGULAR,
	LOADING,
}

interface ChatAttachmentTileProps {
	attachment: Attachment;
	onDelete?: () => void;
	state: ChatAttachmentTileState;
}

const ChatAttachmentTile = ({ attachment, onDelete, state }: ChatAttachmentTileProps) => {
	const theme = useTheme();
	const [isHovered, setIsHovered] = useState(false);
	const ref = useRef(null);

	if (!attachment) {
		console.error("thumbnail being shown for frame that doesn't exist");
		return null;
	}

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	const renderLoadingIndicator = () => {
		return (
			<S.Loader>
				<Loader width={24} height={24} />
			</S.Loader>
		);
	};

	const renderIcon = () => {
		return (
			<S.Icon>
				<Icon type={IconType.FILE} width={26} height={26} color={theme.gray['700']} />
			</S.Icon>
		);
	};

	const renderText = () => {
		return (
			<S.Text>
				<S.Filename>{attachment.filename}</S.Filename>
				<S.FileType>{attachment.contentType}</S.FileType>
			</S.Text>
		);
	};

	return (
		<>
			<S.Base
				ref={ref}
				onMouseEnter={() => setIsHovered(true)}
				onMouseLeave={() => setIsHovered(false)}
			>
				{state === ChatAttachmentTileState.LOADING ? renderLoadingIndicator() : renderIcon()}
				{renderText()}
				{isHovered && onDelete && (
					<S.DeleteIcon>
						<SmallIconButton
							state={SmallIconButtonState.REGULAR}
							iconType={IconType.CLOSE}
							onClick={() => {
								onDelete?.();
							}}
						/>
					</S.DeleteIcon>
				)}
			</S.Base>
		</>
	);
};

export default ChatAttachmentTile;
